import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import withRedirectWithoutASelectedVillage from "../../utils/auth/withRedirectWithoutASelectedVillage";
import {useHistory} from "react-router";
import {RoutePaths} from "../../shared/routePaths";
import {
  multiVillageKeyValue,
  ProcessedBookingsFeatureName
} from "../../shared/constants";
import {Navigation} from "../../utils/navigation";
import {useStores} from "../../stores/useStores";
import ListTransactions from "./bits/listTransactions";
import {isFeatureToggleEnabled} from "../../utils/featureToggle/featureToggle";

// Testing this file means mocking almost everything, it's integration testing, not unit testing
/* istanbul ignore file */
const Transactions: React.FC = () => {
  const history = useHistory();
  const {
    uiStore: {selectableVillages}
  } = useStores();

  useEffect(() => {
    const isMultivillageSelected =
      selectableVillages.selectedItem?.value === multiVillageKeyValue.value;
    const hasSelectedVillage = !!selectableVillages.selectedItem;
    const isFeatureEnabled = isFeatureToggleEnabled(
      `VillageFeature_${ProcessedBookingsFeatureName}_${selectableVillages.selectedItem?.value}`
    );

    if (isMultivillageSelected || (hasSelectedVillage && !isFeatureEnabled)) {
      Navigation.go(history, RoutePaths.Events);
    }
  }, [history, selectableVillages.selectedItem]);

  return <ListTransactions />;
};

export default withRedirectWithoutASelectedVillage(observer(Transactions));
